import { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../Hooks/NoDataFoundTable";
import Pagination from "../../../Hooks/Pagination";
import Swal from "sweetalert2";
import { FaTrashAlt } from "react-icons/fa";
import { blogPostServices } from "../../../APIServices/GlobalManagement/BlogManagement/blogPostServices";

const DeletedBlogPost = ({
  deletedBlogPost,
  softDeleteRestoreBlogPost,
  Show,
  Hide,
  Title,
  getDeletedBlogPostList,
  deletedBlogPostCount,
  pageNumberDeleted,
  itemsPerPageDeleted,
  setPageNumberDeleted,
  setItemsPerPageDeleted,
}) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(deletedBlogPostCount / itemsPerPageDeleted);

  const deleteBlogPost = async (formId) => {
      Swal.fire({
        title: "Are you sure?",
        text: `You want to permanent delete template?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, permanent delete it!`,
      }).then(async (result) => {
        if (!result.isConfirmed) return;
        const userData = {formId};
        const data = await blogPostServices.deleteBlogPost(userData);
        if (data?.statusCode === 200) {
          getDeletedBlogPostList()
        }
      });
    };

  useEffect(() => {
    getDeletedBlogPostList(pageNumberDeleted, itemsPerPageDeleted);
  }, [pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 600 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {deletedBlogPostCount === 0 ? (
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 62px)" }}
            >
              <NoDataFoundTable MSG={"No Mail Templates."} />
            </div>
          ) : (
            <>
              <Table bordered striped hover>
                <thead className="position-sticky top-0">
                  <tr>
                    <th
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th>Name</th>
                    <th
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                    <th
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {deletedBlogPost?.map((item, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{item?.name}</td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreBlogPost(
                              item?.formId,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                      <td className="text-center" title="Permanent Delete">
                        <FaTrashAlt
                          style={{ fontSize: 13 }}
                          onClick={(e) =>
                            deleteBlogPost(item?.formId)
                          }
                          className="text-danger CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={deletedBlogPostCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedBlogPost;
